<template>

  <el-dialog
    class="pto-availability-form-modal"
    :title="modalTitle"
    :visible.sync="formModalOpened"
    :before-close="handleClose"
  >
    <el-form
      ref="ptoAvailabilityForm"
      :model="formData"
      :rules="rules"
      label-position="top"
      v-loading="loading"
      :label-width="$root.labelWidth"
    >
      <h3>Select the number of days below for each category.</h3>
      <el-row :gutter="20">
        <el-col :span="4">&nbsp;</el-col>
        <el-col :span="8" v-for="(category, index) in categories" :key="index">
          <el-form-item :prop="category.name" :label="category.name +' (days)'">
            <el-input-number v-model.lazy.trim="formData.categories[category.id]" controls-position="right" :min="0" :placeholder="$t('modules.ptoAvailability.fields.year.placeholder')"></el-input-number>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>

    <span slot="footer" class="dialog-footer">
      <el-button @click="handleClose">Cancel</el-button>
      <el-button type="primary" @click="submitForm()" :loading="loading">Save</el-button>
    </span>

  </el-dialog>
</template>

<script>
  import { mapGetters, mapActions } from 'vuex';
  import { forEach, get, map, uniq, last } from 'lodash';

  import validations from '@/utils/validations';
  import formPopulator from '@/mixins/form_populator';
  import { showSuccessMessage, showErrorMessage } from '@/ui/message';

  export default {
    name: 'PtoAvailabilityFormModal',
    mixins: [formPopulator],
    props: {
      onSuccess: {
        type: Function,
      },
    },
    created() {
      this.fetchCategories({ type: 'PtoCategory' });

      if (this.editMode) {
        this.populateForm();
      } else {
        this.getLastYear();
      }
    },
    data() {
      return {
        rules: {
          year: [
            { ...validations.required },
          ],
        },
        formData: {
          year: '',
          categories: {},
        },
      };
    },
    computed: {
      ...mapGetters('entities/ptoAvailabilities', ['creating', 'updating', 'formModalContext']),

      formModalOpened: {
        get() {
          return this.$store.getters['entities/ptoAvailabilities/formModalOpened'];
        },
        set(newValue) {
          if (!newValue) {
            this.closeFormModal();
          }
        },
      },


      editMode() {
        return get(this, 'formModalContext.year') !== undefined;
      },

      modalTitle() {
        return this.editMode ? `Edit PTO Availability (${this.formData.year})` : `Add new PTO Availability (${this.formData.year})`;
      },

      categories() {
        return this.$store.getters['entities/categories/query']()
          .where('type', 'PtoCategory')
          .get();
      },

      loading() {
        return this.updating || this.creating;
      },

      ptoAvailabilities() {
        return this.$store.getters['entities/ptoAvailabilities/query']()
          .where('user_id', this.formModalContext.user_id)
          .where('year', parseInt(this.formModalContext.year, 10))
          .get();
      },
    },
    methods: {
      ...mapActions('entities/ptoAvailabilities', ['createPtoAvailability', 'updatePtoAvailability', 'fetchPtoAvailabilities', 'closeFormModal']),
      ...mapActions('entities/categories', ['fetchCategories', 'fetching']),

      getLastYear() {
        this.fetchPtoAvailabilities({ ...this.formModalContext })
          .then((response) => {
            let latestYear = new Date().getFullYear();
            if (response.data.entities.length > 0) {
              latestYear = Number(last(uniq(map(response.data.entities, 'year')))) + 1;
            }
            this.formData.year = latestYear;
          });
      },

      submitForm() {
        this.$refs.ptoAvailabilityForm.validate((valid) => {
          if (valid) {
            if (this.editMode) {
              this.updatePtoAvailability({ ...this.formModalContext, ...this.formData })
                .then((response) => {
                  if (response.status) {
                    showSuccessMessage('PtoAvailability has been edited successfully');
                    this.handleClose();
                  } else {
                    showErrorMessage(response.error);
                  }
                });
            } else {
              this.createPtoAvailability({ ...this.formModalContext, ...this.formData })
                .then((response) => {
                  if (response.status) {
                    showSuccessMessage('PtoAvailability has been saved.');
                    this.handleClose();

                    if (this.onSuccess) this.onSuccess(response);
                  } else {
                    showErrorMessage(response.error);
                  }
                });
            }
          } else {
            showErrorMessage(this.$t('form.messages.notValid'));

            return false;
          }

          return true;
        });
      },

      populateForm() {
        const data = {
          year: this.formModalContext.year,
          categories: {},
        };

        forEach(this.ptoAvailabilities, (ptoAvailability) => {
          data.categories[ptoAvailability.category_id] = ptoAvailability.total;
        });

        this.populateFormWithModel(data);
      },

      clearForm() {
        this.$refs.ptoAvailabilityForm.resetFields();
      },

      handleClose() {
        this.closeFormModal();
      },

    },

  };
</script>

<style lang="scss">
  .pto-availability-form-modal {
    .category {
      margin-bottom: 10px;
    }
  }
</style>


// WEBPACK FOOTER //
// src/components/ptoAvailability/PtoAvailabilityFormModal.vue